/**
 * NumericRangeFilter Component
 * 
 * Number input for numeric comparisons, with special handling for 'between' operator.
 */

import React from 'react';
import {
  HStack,
  Input,
  Text,
  InputGroup,
  InputLeftAddon,
} from '@chakra-ui/react';

/**
 * NumericRangeFilter - Number input(s) for numeric filters
 */
export default function NumericRangeFilter({
  operator,
  value,
  onChange,
  prefix = '',  // Optional prefix like '$' for money fields
  suffix = '',  // Optional suffix like '%' for percentage fields
}) {
  // For between, show two inputs
  if (operator === 'between') {
    const [minVal, maxVal] = Array.isArray(value) ? value : ['', ''];
    
    return (
      <HStack spacing={2}>
        <InputGroup size="sm" maxW="120px">
          {prefix && <InputLeftAddon>{prefix}</InputLeftAddon>}
          <Input
            type="number"
            placeholder="Min"
            value={minVal || ''}
            onChange={(e) => onChange([e.target.value, maxVal])}
          />
        </InputGroup>
        <Text fontSize="sm" color="gray.500">to</Text>
        <InputGroup size="sm" maxW="120px">
          {prefix && <InputLeftAddon>{prefix}</InputLeftAddon>}
          <Input
            type="number"
            placeholder="Max"
            value={maxVal || ''}
            onChange={(e) => onChange([minVal, e.target.value])}
          />
        </InputGroup>
      </HStack>
    );
  }
  
  // Default single number input
  return (
    <InputGroup size="sm" maxW="150px">
      {prefix && <InputLeftAddon>{prefix}</InputLeftAddon>}
      <Input
        type="number"
        placeholder="Enter value..."
        value={value || ''}
        onChange={(e) => onChange(e.target.value ? Number(e.target.value) : '')}
      />
    </InputGroup>
  );
}
